import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './index.css'

// Optional Adobe Fonts (Typekit) kit for real Futura PT. Jost is the default.
const kit = import.meta.env.VITE_TYPEKIT_KIT_ID
if (kit && /^[a-z0-9]+$/i.test(kit)) {
  const link = document.createElement('link')
  link.rel = 'stylesheet'
  link.href = `https://use.typekit.net/${kit}.css`
  link.onload = () => document.documentElement.classList.add('typekit')
  document.head.appendChild(link)
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
)
